module.exports = __webpack_public_path__ + "media/images/mobile/border_pink_v-c39f2848b8c0c5849ad931c1cc48337e.gif";